import { Injectable } from '@angular/core';
import { merge } from 'lodash';
import { BehaviorSubject } from 'rxjs';

import { DEFAULT_UI_OPTIONS, IUiFeatures, IUiOptions } from '../models/ui-options';

import { MenuOptionsService } from './menu-options.service';

/** A service to update the mouse mode */
@Injectable({ providedIn: 'root' })
export class UiOptionsService {
    uiOptions$:  BehaviorSubject<IUiOptions> = new BehaviorSubject( DEFAULT_UI_OPTIONS );

    constructor( private _menuOptionsService: MenuOptionsService ) {}

    /** set the ui options for all plots */
    setUiOptions( options: IUiOptions ) {
        if ( !options.features.globalSettings ) {
            this._menuOptionsService.disableGlobalOptions();
        }
        this.uiOptions$.next( options );
    }

    /** update the features section of the UI options with a new features config */
    updateFeatures( features: IUiFeatures ) {
        const options = this.uiOptions$.getValue();
        if ( !options.features.globalSettings ) {
            this._menuOptionsService.disableGlobalOptions();
        }
        this.uiOptions$.next( merge( options, { features: features }) );
    }

    /** toggle the dark theme on/off */
    setDarkMode( mode: 'light' | 'dark' ) {
        const options = this.uiOptions$.getValue();
        this.uiOptions$.next( merge( options, { darkTheme: mode === 'dark' }) );
    }

    /** set the number of rows and columns we want to display per page */
    setPlotGrid( rows: number, cols: number ) {
        const options = this.uiOptions$.getValue();
        this.uiOptions$.next( merge( options, { grid: { rows: rows, cols: cols } }));
    }

    /** get the ui options config */
    getUiOptions() {
        return this.uiOptions$.getValue();
    }

    /** returns an observable that emits whenever we update the ui options */
    getUiOptions$() {
        return this.uiOptions$;
    }
}
